import { ShortSB } from 'module/ui/components/styles';
import { FormattedMessage } from 'react-intl';
import styled, { css } from 'styled-components';

const Tab = styled.div<{ $active: boolean }>`
  ${ShortSB};
  padding: 0 var(--spacing-03);
  border-radius: var(--border-radius-default);
  ${({ $active }) =>
    $active
      ? css`
          background-color: var(--scarlet-background-tertiary);
          color: var(--text-selected);
        `
      : css`
          color: var(--text-secondary);
          cursor: pointer;
        `};
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const TabsContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  height: 32px;
  border-radius: var(--border-radius-small);
  overflow: hidden;
  border: 2px solid var(--field-border-focused);
  display: flex;
  align-items: center;
  padding: var(--spacing-01);
  ${Tab} {
    flex: 1;
  }
`;
const Wrapper = styled.div`
  padding: var(--spacing-03) 0;
  border-bottom: 1px solid var(--field-border-focused);
`;

export enum KnowledgeBaseFileViewerTab {
  Preview = 'preview',
  Metadata = 'metadata',
}
type Props = {
  activeTab: KnowledgeBaseFileViewerTab;
  onChange: (tab: KnowledgeBaseFileViewerTab) => void;
};

export const KnowledgeBaseFileViewerTabs = ({ activeTab, onChange }: Props) => {
  return (
    <Wrapper>
      <TabsContainer>
        <Tab
          $active={activeTab === KnowledgeBaseFileViewerTab.Preview}
          onClick={() => onChange(KnowledgeBaseFileViewerTab.Preview)}
        >
          <FormattedMessage id="knowledge_base.file_viewer.tabs.preview" />
        </Tab>
        <Tab
          $active={activeTab === KnowledgeBaseFileViewerTab.Metadata}
          onClick={() => onChange(KnowledgeBaseFileViewerTab.Metadata)}
        >
          <FormattedMessage id="knowledge_base.file_viewer.tabs.metadata" />
        </Tab>
      </TabsContainer>
    </Wrapper>
  );
};
